const timeViews = {
  hours: "соат",
  minutes: "дақиқа",
  seconds: "сония",
  meridiem: "кундузи/кечаси",
};

export const uzUZCyrlPickers = {
  // Calendar navigation
  previousMonth: "Олдинги ой",
  nextMonth: "Кейинги ой",
  // View navigation
  openPreviousView: "Олдинги кўринишни очиш",
  openNextView: "Кейинги кўринишни очиш",
  calendarViewSwitchingButtonAriaLabel: (view) =>
    view === "year"
      ? "йил кўриниши очилган, календарь кўринишига ўтиш"
      : "календарь кўриниши очилган, йил кўринишига ўтиш",
  // DateRange labels
  start: "Бошланиш",
  end: "Тугаш",
  startDate: "Бошланиш санаси",
  startTime: "Бошланиш вақти",
  endDate: "Тугаш санаси",
  endTime: "Тугаш вақти",
  // Action bar
  cancelButtonLabel: "Бекор қилиш",
  clearButtonLabel: "Тозалаш",
  okButtonLabel: "Ок",
  todayButtonLabel: "Бугун",
  // Toolbar titles
  datePickerToolbarTitle: "Санани танланг",
  dateTimePickerToolbarTitle: "Сана ва вақтни танланг",
  timePickerToolbarTitle: "Вақтни танланг",
  dateRangePickerToolbarTitle: "Давр танланг",
  // Clock labels
  clockLabelText: (view, time, utils, formattedTime) =>
    `${timeViews[view]}ни танланг. ${
      !formattedTime && (time === null || !utils.isValid(time))
        ? "Вақт танланмаган"
        : `Вақт танланди ${formattedTime ?? utils.format(time, "fullTime")}`
    }`,
  hoursClockNumberText: (hours) => `${hours} соат`,
  minutesClockNumberText: (minutes) => `${minutes} дақиқа`,
  secondsClockNumberText: (seconds) => `${seconds} сония`,
  // Digital clock labels
  selectViewText: (view) => `${timeViews[view]}ни танланг`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Ҳафта рақами",
  calendarWeekNumberHeaderText: "№",
  calendarWeekNumberAriaLabelText: (weekNumber) => `${weekNumber}-ҳафта`,
  calendarWeekNumberText: (weekNumber) => `${weekNumber}`,
  // Open picker labels
  openDatePickerDialogue: (value, utils, formattedDate) =>
    formattedDate || (value !== null && utils.isValid(value))
      ? `Санани танланг, танланган сана ${
          formattedDate ?? utils.format(value, "fullDate")
        }`
      : "Санани танланг",
  openTimePickerDialogue: (value, utils, formattedTime) =>
    formattedTime || (value !== null && utils.isValid(value))
      ? `Вақтни танланг, танланган вақт ${
          formattedTime ?? utils.format(value, "fullTime")
        }`
      : "Вақтни танланг",
  fieldClearLabel: "Қийматни ўчириш",
  // Table labels
  timeTableLabel: "вақтни танланг",
  dateTableLabel: "санани танланг",
  // Field section placeholders
  fieldYearPlaceholder: (params) => "Й".repeat(params.digitAmount),
  fieldMonthPlaceholder: (params) =>
    params.contentType === "letter" ? "ОООО" : "ОО",
  fieldDayPlaceholder: () => "КУН",
  fieldWeekDayPlaceholder: (params) =>
    params.contentType === "letter" ? "ҲАФТА" : "ҲФТ",
  fieldHoursPlaceholder: () => "СС",
  fieldMinutesPlaceholder: () => "ДҚ",
  fieldSecondsPlaceholder: () => "СН",
  fieldMeridiemPlaceholder: () => "К/Т",
  // View names
  year: "Йил",
  month: "Ой",
  day: "Кун",
  weekDay: "Ҳафта куни",
  hours: "Соат",
  minutes: "Дақиқа",
  seconds: "Сония",
  meridiem: "Кундузи/Кечаси",
  // Common
  empty: "Бўш",
};
